(function() {
  if (window.__aathiGstDisplayInstalled) return;
  window.__aathiGstDisplayInstalled = true;

  var style = document.createElement('style');
  style.textContent = [
    '.aathi-gst-note{margin:6px 0 0;color:rgba(32,39,34,.66);font-size:12px;font-weight:800;line-height:1.25}',
    '.aathi-product__tax-note,.aathi-product-card__tax,.aathi-card__tax{letter-spacing:0}'
  ].join('');
  document.head.appendChild(style);

  function textFrom(node) {
    return node ? (node.textContent || '').toLowerCase() : '';
  }

  function gstRate(scope) {
    var text = [
      textFrom(scope.querySelector('.aathi-card__title')),
      textFrom(scope.querySelector('.aathi-product-card__content > a')),
      textFrom(scope.querySelector('h1')),
      textFrom(scope.querySelector('.aathi-product__eyebrow'))
    ].join(' ');
    return text.indexOf('perfume') !== -1 ? '18%' : '3%';
  }

  function addNote(scope, priceSelector, className, longCopy) {
    var price = scope.querySelector(priceSelector);
    if (!price || scope.querySelector('.' + className)) return;

    var note = document.createElement('p');
    note.className = className + ' aathi-gst-note';
    note.textContent = gstRate(scope) + (longCopy ? ' GST included in price. Shipping calculated at checkout.' : ' GST included');
    price.insertAdjacentElement('afterend', note);
  }

  function updateStaticCopy(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      if (!value) continue;
      var nextValue = value
        .replace('Taxes and shipping calculated at checkout.', 'GST included. Shipping calculated at checkout.')
        .replace('Taxes calculated at checkout.', 'GST included.')
        .replace('Tax included', 'GST included');
      if (nextValue !== value) node.nodeValue = nextValue;
    }
  }

  function apply(root) {
    root = root || document;
    root.querySelectorAll('.aathi-product-card').forEach(function(card) {
      addNote(card, '.aathi-product-card__price', 'aathi-product-card__tax', false);
    });
    root.querySelectorAll('.aathi-card').forEach(function(card) {
      addNote(card, '.aathi-card__price', 'aathi-card__tax', false);
    });
    root.querySelectorAll('.aathi-product').forEach(function(product) {
      addNote(product, '.aathi-product__price', 'aathi-product__tax-note', true);
    });
    updateStaticCopy(root.body || root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { apply(document); });
  } else {
    apply(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    apply(event.target);
  });
})();
